// extracted by mini-css-extract-plugin
module.exports = {"fill":"Icon_fill__3Grr-"};